export default __webpack_public_path__ + "static/media/PieVenerini.b63dbd50.png";